import { KnownLDFlags, selectAllLDFlags } from "app/store/LDFeatureFlagsSlice";

import useStaticStores from "./store/useStaticStores";

const useAllLDFlags = (): KnownLDFlags => {
  return useStaticStores(selectAllLDFlags);
};

export default useAllLDFlags;
